import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Typography,
  Box,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import styles from '../styles/Checklist.module.css';

const categories = [
  'Venue',
  'Wedding website',
  'Photos & videos',
  'Food & drink',
  'Attire',
  'Music',
  'Flowers & decor',
  'Registry',
  'Invitations & paper',
  'Beauty',
  'Ceremony',
  'Guests',
  'Travel',
  'Details',
];

const ChecklistItemModal = ({
  open,
  item,
  onClose,
  onSave,
  onDelete,
  onToggle,
}) => {
  const [editedItem, setEditedItem] = React.useState(null);

  React.useEffect(() => {
    if (item) {
      setEditedItem(item);
    }
  }, [item]);

  if (!item || !editedItem) {
    return null;
  }

  const handleDelete = () => {
    onDelete(item._id);
    onClose();
  };

  const handleSave = () => {
    if (editedItem._id) {
      onSave(editedItem);
    } else {
      const { _id, ...newItem } = editedItem;
      onSave(newItem);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullScreen className={styles.modal}>
      <DialogTitle>Task Details</DialogTitle>
      <DialogContent className={styles.modalContent}>
        <Box className={styles.modalCheckbox}>
          <Checkbox
            checked={editedItem.isDone}
            onChange={() => {
              if (!editedItem._id) {
                setEditedItem({ ...editedItem, isDone: !editedItem.isDone });
              } else {
                onToggle(item);
                setEditedItem({ ...editedItem, isDone: !editedItem.isDone });
              }
            }}
          />
          <Typography>
            {editedItem.isDone ? 'Mark as Undone' : 'Mark as Done'}
          </Typography>
        </Box>
        <TextField
          fullWidth
          label="Task Name"
          value={editedItem.taskItemName}
          onChange={(e) =>
            setEditedItem({ ...editedItem, taskItemName: e.target.value })
          }
          className={styles.modalTextField}
        />
        <TextField
          fullWidth
          label="Task Tip"
          multiline
          rows={2}
          value={editedItem.taskItemTip || ''}
          onChange={(e) =>
            setEditedItem({ ...editedItem, taskItemTip: e.target.value })
          }
          className={styles.modalTextField}
        />
        <FormControl className={styles.modalFormControl}>
          <InputLabel className={styles.modalLabel}>Category</InputLabel>
          <Select
            value={editedItem.category}
            onChange={(e) =>
              setEditedItem({ ...editedItem, category: e.target.value })
            }
            label="Category"
          >
            {categories.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Due Date"
            value={new Date(editedItem.dueBy)}
            onChange={(newDate) =>
              setEditedItem({ ...editedItem, dueBy: newDate })
            }
            className={styles.modalDatePicker}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions className={styles.modalActions}>
        <Button onClick={handleDelete} color="error">
          Delete
        </Button>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChecklistItemModal;
